import { DashboardCalendarStatus, type DashboardStats } from '@/types/composition-functions';

export interface CurrentWeekCard {
  headline: string;
  detail: string;
}

/**
 * The dashboard's "Current Week" card. It used to print the week number and
 * the days left in the week whatever the calendar's state, so a calendar that
 * ended in December read "Week 64, ending in 5 days" ten months later.
 */
export function currentWeekCard(
  stats: Pick<DashboardStats, 'currentWeek' | 'weekEndsInDays' | 'calendarStatus'> | null | undefined,
): CurrentWeekCard {
  const week = stats?.currentWeek ?? 0;
  switch (stats?.calendarStatus) {
  case DashboardCalendarStatus.Ended:
    return { headline: 'Calendar ended', detail: `Ended after week ${week}. Set the next calendar as active.` };
  case DashboardCalendarStatus.NotStarted:
    return { headline: 'Not started', detail: 'The active calendar has not started yet.' };
  case DashboardCalendarStatus.None:
    return { headline: 'No calendar', detail: 'Set an active academic calendar to track weeks.' };
  default: {
    const days = stats?.weekEndsInDays ?? 0;
    return {
      headline: `Week ${week}`,
      detail: days === 0 ? 'Ends today' : `Ending in ${days} ${days === 1 ? 'day' : 'days'}`,
    };
  }
  }
}
